import React from "react";
import { Page } from "../../components/page/page";
import styles from "./relationship-status.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setRelationshipStatus } from "../../store/stateSlice";

const options = [
  {
    value: "single",
    icon: "👩",
    link: "../what-drives-you",
  },
  {
    value: "in a relationship",
    icon: "💑",
    link: "../what-drives-you",
  },
  {
    value: "married",
    icon: "💍",
    link: "../what-drives-you",
  },
  {
    value: "it is complicated",
    icon: "😕",
    link: "../what-drives-you",
  },
  {
    value: "looking for a soulmate",
    icon: "🔎",
    link: "../what-drives-you",
  },
  {
    value: "other",
    icon: "✨",
    link: "../what-drives-you",
  },
];

const RelationshipStatusPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="What’s your relationship status?"
      hideContinueButton={true}
      currentStep={6}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to={option.link}
              onClick={() => dispatch(setRelationshipStatus(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { RelationshipStatusPage };
